import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router";

import CustomButton from "../../CustomButton";

const EmptyNotification = () => {
  const navigate = useNavigate();

  return (
    <Box>
      <Typography
        sx={{
          fontSize: "32px",
          fontWeight: "500",
          lineHeight: "40px",
          mt: "64px",
          mb: "16px",
        }}
      >
        You don't have any <br /> notifications yet!
      </Typography>
      <Typography sx={{ fontSize: "18px", mb: "16px", color: "gray.main" }}>
        Find a table, then enroll in it to receive notifications!
      </Typography>

      <CustomButton
        title='Find a table'
        onClick={() => navigate("/explore")}
        fSize='20px'
        width='100%'
        height='48px'
        bShadow='4px'
        bgColor='primary.main'
      />
    </Box>
  );
};

export default EmptyNotification;
